import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as instructorActions from '../../_actions/roster.actions'

import _ from 'lodash'
import BigCalendar from 'react-big-calendar'
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
// import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css'
import { Menubar } from 'primereact/menubar'

import ETimeForm from '../etimeform/ETimeForm'
// react-bootstrap modal
import Draggable from 'react-draggable'
import Modal from 'react-bootstrap/Modal'
import * as ModalDialog from 'react-bootstrap/ModalDialog'
import { DndProvider } from 'react-dnd'
import { denormalize } from 'normalizr'
import TimeUtils from '../../utils/TimeUtils'
import ToolBar from './Toolbar'
import DraggableModalDialog from '../common/DraggableModalDialog'
import { eventSchema } from './../../entities/schema'

import './css/calendar.css'

const moment = require('moment')
const localizer = BigCalendar.momentLocalizer(moment)
const DragAndDropCalendar = withDragAndDrop(BigCalendar, DndProvider)

const WHOLE_DAY = 86400000

const ActionTypes = {
    NORMAL_WORKING: 99,
    ANNUAL_LEAVE: 1,
    SICK_LEAVE: 2,
    ALTERNATIVE_LEAVE: 3,
    BEREAVEMENT_LEAVE: 4,
    LONGSERVICE_LEAVE: 5,
    SPECIAL_SERVICE_LEAVE: 6,
    DOMESTIC_LEAVE: 7,
    OTHER_PAID_LEAVE: 8,
    UNPAID_LEAVE: 9,
    OVERTIME_LIEU_LEAVE: 10,
    STUDY_LEAVE: 11,
    BIRTHDAY_LEAVE: 12,
    PARENTAL_LEAVE: 13,
}

const ActionOptions = {
    NORMAL_WORKING: 'Normal working',
    ANNUAL_LEAVE: 'Annual Leave',
    SICK_LEAVE: 'Sick Leave',
    ALTERNATIVE_LEAVE: 'Alternative Leave',
    BEREAVEMENT_LEAVE: 'Bereavement Leave',
    OT_LEAVE: 'Overtime in Lieu Leave',
    OTHER_LEAVE: 'Other Paid Leave',
    PARENTAL_LEAVE: 'Parental Leave',
    UNPAID_LEAVE: 'Unpaid Leave',
    LONG_SERVICE_LEAVE: 'Long Service Leave',
    SPECIAL_SERVICE_LEAVE: 'Special Service Leave',
    DOMESTIC_LEAVE: 'Domestic Leave',
    STUDY_LEAVE: 'Study Leave',
    BIRTHDAY_LEAVE: 'Birthday Leave',
}

const customStyles = {
    content: {
        top: '70%',
        left: '70%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-70%',
        transform: 'translate(-50%, -50%)',
    },
}

class CalendarWithContainer extends React.PureComponent {
    state = {
        currentMonth: new Date(),
        selectedDate: new Date(),
        showModal: false,
        event: {},
        show: false,
    }

    handleOpenModal = () => {
        this.setState({ showModal: true })
    }

    handleCloseModal = () => {
        this.setState({ showModal: false })
    }

    handleClose = () => {
        this.setState({ show: false })
    }

    handleShow = () => {
        this.setState({ show: true })
    }

    moveEvent = ({ event, start, end, isAllDay: droppedOnAllDaySlot }) => {
        // alert(`${event.title} was dropped onto ${start}-${end}`)
        const { events } = this.props

        // const idx = events.indexOf(event);
        let allDay = event.allDay

        if (!event.allDay && droppedOnAllDaySlot) {
            allDay = true
        } else if (event.allDay && !droppedOnAllDaySlot) {
            allDay = false
        }

        const updatedEvent = { ...event, start, end, allDay }

        this.props.actions.updateEvent(updatedEvent)

        // alert(`${event.title} was dropped onto ${updatedEvent.start}`)
    }

    extendEvent = (event, start, end, sameStart, sameEnd) => {
        const eventList = []

        const newStartTime = TimeUtils.extractTime(event.start)
        const newEndTime = TimeUtils.extractTime(event.end)

        const minStart = moment.min([moment(start), moment(event.start)])
        const maxEnd = moment.max([moment(end), moment(event.end)])

        //
        // const oneDay = moment.duration(1, 'd');
        //       const newEndDate = sameStart ? TimeUtils.extractDate(moment(end).subtract(oneDay)) : TimeUtils.extractDate(end)
        const adjustedMaxEnd = sameStart ? maxEnd.subtract(1, 'days') : maxEnd

        const eventStart = moment(TimeUtils.extractDate(minStart))
        const eventEnd = moment(TimeUtils.extractDate(maxEnd))

        let day = eventStart
        const cloneEvent = _.clone(event)

        while (day <= adjustedMaxEnd) {
            let currentDay = day
            cloneEvent.start = moment(
                TimeUtils.combineDateNTime(day.clone(), newStartTime)
            )
            cloneEvent.end = moment(
                TimeUtils.combineDateNTime(day.clone(), newEndTime)
            )

            day.add(1, 'days')

            // exclude same event
            if (
                cloneEvent.start.isSame(event.start) &&
                cloneEvent.end.isSame(event.end)
            ) {
                console.log('same event')
            } else {
                delete cloneEvent.id
                console.log(JSON.stringify(cloneEvent))
                this.props.actions.updateEvent(cloneEvent)
            }
        }
    }

    resizeEvent = ({ event, start, end }) => {
        // sameday: if start equal event.start && end == 24 hours from start
        //
        console.log(`resize start: ${start}, end: ${end}`)

        const { events } = this.props

        const duration = moment(end).diff(start) == WHOLE_DAY // 24 hours
        const sameStart = moment(start).isSame(event.start)
        const sameEnd = moment(end).isSame(event.end)
        const orgDuration = moment(event.end).diff(event.start) > WHOLE_DAY
        const sameDayEvent =
            moment(event.end).diff(event.start) < WHOLE_DAY &&
            moment(TimeUtils.extractDate(event.end)).isSame(
                TimeUtils.extractDate(event.start)
            )

        const nextEvents = _.find(events, { id: event.id })

        // same day event
        if (sameDayEvent) {
            // repeatable event, expand to multiple days
            let period = 0
            if (sameStart) {
                period = moment(end).diff(event.start, 'days')
            }
            if (sameEnd) {
                period = moment(event.end).diff(start, 'days')
            }

            const multiple = period > 0

            if (multiple) {
                // repeat same event
                const newEventList = this.extendEvent(
                    nextEvents,
                    start,
                    end,
                    sameStart,
                    sameEnd
                )
                console.log('')
            } else {
                // within same day
                const newStartDate = TimeUtils.extractDate(start)
                const newStartTime = TimeUtils.extractTime(start)
                const newStart = TimeUtils.combineDateNTime(
                    newStartDate,
                    newStartTime
                )

                const newEndDate = TimeUtils.extractDate(end)
                const newEndTime = TimeUtils.extractTime(end)
                const newEnd = TimeUtils.combineDateNTime(
                    newEndDate,
                    newEndTime
                )

                nextEvents.start = moment(newStart)
                nextEvents.end = moment(newEnd)
                nextEvents.allDay = false
                this.props.actions.updateEvent(nextEvents)
            }
        }

        // whole period event, not repeatable
        if (!sameDayEvent) {
            // resize to the one day
            if (duration && (sameStart || sameEnd) && orgDuration) {
                const newEvtDate = sameStart
                    ? TimeUtils.extractDate(start)
                    : TimeUtils.extractDate(end)

                const sTime = TimeUtils.extractTime(event.start)
                const newStartDate = TimeUtils.combineDateNTime(
                    newEvtDate,
                    sTime
                )

                const eTime = TimeUtils.extractTime(event.end)
                const newEndDate = TimeUtils.combineDateNTime(newEvtDate, eTime)

                nextEvents.start = moment(newStartDate)
                nextEvents.end = moment(newEndDate)
                nextEvents.allDay = false
            } else {
                // extend to multiple days
                const overOneDay = moment(end).diff(event.start) > WHOLE_DAY

                if (overOneDay) {
                    const newStartDate = TimeUtils.extractDate(start)
                    const newStartTime = TimeUtils.extractTime(event.start)
                    const newStart = TimeUtils.combineDateNTime(
                        newStartDate,
                        newStartTime
                    )

                    // expand over one day event, same start, then -1 day
                    const oneDay = moment.duration(1, 'd')
                    const newEndDate = sameStart
                        ? TimeUtils.extractDate(moment(end).subtract(oneDay))
                        : TimeUtils.extractDate(end)
                    const newEndTime = TimeUtils.extractTime(event.end)
                    const newEnd = TimeUtils.combineDateNTime(
                        newEndDate,
                        newEndTime
                    )

                    nextEvents.start = moment(newStart)
                    nextEvents.end = moment(newEnd)
                    nextEvents.allDay = false
                } else {
                    // within same day
                    const newStartDate = TimeUtils.extractDate(start)
                    const newStartTime = TimeUtils.extractTime(start)
                    const newStart = TimeUtils.combineDateNTime(
                        newStartDate,
                        newStartTime
                    )

                    const newEndDate = TimeUtils.extractDate(end)
                    const newEndTime = TimeUtils.extractTime(end)
                    const newEnd = TimeUtils.combineDateNTime(
                        newEndDate,
                        newEndTime
                    )

                    nextEvents.start = moment(newStart)
                    nextEvents.end = moment(newEnd)
                    nextEvents.allDay = false
                }
            }
            this.props.actions.updateEvent(nextEvents)
        }

        // alert(`${event.title} was resized to ${start}-${end}`)
    }

    newEvent = event => {
        // if (this.props.readOnly) {
        // }
        let eTimeRequest = {
            id: '',
            title: '',
            actionType: this.props.readOnly
                ? {
                      label: ActionOptions.ANNUAL_LEAVE,
                      value: ActionTypes.ANNUAL_LEAVE,
                  }
                : {
                      label: ActionOptions.NORMAL_WORKING,
                      value: ActionTypes.NORMAL_WORKING,
                  },
            allDay: event.slots.length == 1,
            dateFrom: event.start,
            dateTo: event.end,
            draggable: true,
            status: 'edit',
            startTime: TimeUtils.extractTime(event.start),
            endTime: TimeUtils.extractTime(event.end),
            duration: '',
            break: event.break || '0.0',
            note: '',
            existing: false,
        }

        this.setState({ event: eTimeRequest })
        // ReactModal.setAppElement(document.getElementById('calendarModal'));
        // this.handleOpenModal();
        this.handleShow()
    }

    customEventPropGetter = event => {
        const eventType = event.ActionType
        if (eventType) {
            switch (eventType) {
                case ActionTypes.NORMAL_WORKING:
                    return {
                        className: 'boxGreen',
                    }
                case ActionTypes.ANNUAL_LEAVE:
                    return {
                        className: 'boxTomato',
                    }
                case ActionTypes.SICK_LEAVE:
                    return {
                        className: 'boxOrange',
                    }
                case ActionTypes.ALTERNATIVE_LEAVE:
                    return {
                        className: 'boxDodgerBlue',
                    }
                case ActionTypes.BEREAVEMENT_LEAVE:
                    return {
                        className: 'boxMediumSeaGreen',
                    }
                case ActionTypes.OVERTIME_LIEU_LEAVE:
                    return {
                        className: 'boxGray',
                    }
                case ActionTypes.OTHER_PAID_LEAVE:
                    return {
                        className: 'boxViolet',
                    }
                case ActionTypes.PARENTAL_LEAVE:
                    return {
                        className: 'boxSlateBlue',
                    }
                case ActionTypes.UNPAID_LEAVE:
                    return {
                        className: 'boxLightGray',
                    }
                case ActionTypes.LONGSERVICE_LEAVE:
                    return {
                        className: 'boxLight-1',
                    }
                case ActionTypes.SPECIAL_SERVICE_LEAVE:
                    return {
                        className: 'boxLight-2',
                    }
                case ActionTypes.DOMESTIC_LEAVE:
                    return {
                        className: 'boxLight-3',
                    }
                case ActionTypes.STUDY_LEAVE:
                    return {
                        className: 'boxLight-4',
                    }
                case ActionTypes.BIRTHDAY_LEAVE:
                    return {
                        className: 'boxLight-5',
                    }
                default:
                    return {
                        className: 'boxDodgerBlue',
                    }
            }
        } else return {}
    }

    renderEvetDetail = event => {
        let eTimeRequest = {
            id: event.id,
            title: event.Title || event.title,
            actionType: _.find(this.props.actionTypes, {
                value: event.ActionType,
            }),
            allDay: event.allDay,
            dateFrom: event.start,
            dateTo: event.end,
            startTime: TimeUtils.extractTime(event.start),
            endTime: TimeUtils.extractTime(event.end),
            duration: event.ActionHours || '',
            break: event.Break || '0',
            Note: event.Note || '',
            existing: true,
            status: event.Status,
            employeeID: event.EmployeeID,
            hours: event.hours,
        }

        this.setState({ event: eTimeRequest })

        // ReactModal.setAppElement(document.getElementById('calendarModal'));
        // this.handleOpenModal();
        this.handleShow()
    }

    removeEvent = event => {
        this.props.actions
            .removeEventById(this.state.event.id)
            .then(res =>
                _.head(document.getElementsByClassName('close')).click()
            )
            .catch(error => {
                console.log(`error=${error}`)
            })
    }

    render() {
        let allViews = Object.keys(BigCalendar.Views).map(
            k => BigCalendar.Views[k]
        )
        let components = {
            toolbar: ToolBar,
        }

        return (
            <div className="container">
                {/* <div className="row">
                    <div className="col-sm-12 col-md-12">
                        <Menubar model={items} />
                    </div>
                </div> */}
                <div className="row">
                    <div className="col-md-12">
                        <div className="panel">
                            <div className="panel-heading">
                                <h3 className="panel-title">Calendar</h3>
                            </div>
                            <div className="panel-body">
                                <div className="calendar">
                                    <div className="example">
                                        <BigCalendar
                                            popup
                                            selectable
                                            localizer={localizer}
                                            events={_.map(
                                                this.props.normalizedData,
                                                (obj, key) => {
                                                    return obj
                                                }
                                            )}
                                            // onEventDrop={this.moveEvent}
                                            // onEventResize={this.resizeEvent}
                                            onSelectEvent={
                                                this.renderEvetDetail
                                            }
                                            // onSelectSlot={this.newEvent}
                                            views={['month', 'week', 'day']}
                                            defaultView={
                                                BigCalendar.Views.MONTH
                                            }
                                            defaultDate={new Date()}
                                            eventPropGetter={
                                                this.customEventPropGetter
                                            }
                                            titleAccessor="Title"
                                            startAccessor="start"
                                            endAccessor="end"
                                            showMultiDayTimes={true}
                                            // draggableAccessor="draggable"
                                            culture="en-NZ"
                                            tooltipAccessor="Title"
                                            classNameCustom="rbc-calendar"
                                            components={components}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    dialogComponentClass={DraggableModalDialog}
                    dialogClassName="mod-w450"
                    show={this.state.show}
                    onHide={this.handleClose}
                >
                    <div>
                        <div>
                            <Modal.Header closeButton>
                                <Modal.Title>
                                    Request Absence/Attendance
                                </Modal.Title>
                            </Modal.Header>
                            <ETimeForm
                                event={this.state.event}
                                actionTypes={
                                    this.props.readOnly
                                        ? _.slice(this.props.actionTypes, 1)
                                        : this.props.actionTypes
                                }
                                renderContent="calendar"
                                readOnly={true}
                                actions={this.props.actions}
                            />
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        actionTypes: state.ActionTypesReducer.actionTypes,
        normalizedData: state.etime.events,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(instructorActions, dispatch) }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CalendarWithContainer)
